export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const GREY = '#939393';
export const DARK_GREY = '#666666';
export const SCOUT_BLUE = '#084d6d';
export const SCOUT_BLUE_DARK = '#05354c';
export const SCOUT_TEAL = '#5BC4BF';
export const SCOUT_SECONDARY_BLUE = '#5BC4BF';
export const SCOUT_SECONDARY_LIGHT_BLUE = '#EEFBFB';
export const DARK_TEAL = '#418B88';
export const LIGHT_TEAL = '#DEF3F2';
export const GREEN = '#429E4D';
export const LIGHT_GREEN = '#EEFAF1';
export const SUCCESS_GREEN = '#8CCF95';
export const RED = '#DE6763';
export const LIGHT_RED = '#FCEFEF';
export const DARK_RED = '#D32F2F';
export const DEEP_BLUE = '#2D388D';

export const LIGHT_BLUE = '#6DBEBF';
export const PURPLE = '#9268F7';
export const PINK = '#F7A1FF';
export const MEDIUM_RED = '#EC6E85';
export const DARK_BLUE = '#7EA7E4';
export const BRIGHT_BLUE = '#7A8EF1';
export const YELLOW = '#E6A052';

// Neutrals for text, borders and surfaces. These were hardcoded across NewUI
// with no token to migrate to — BODY_TEXT ~158 occurrences, DIVIDER ~144,
// BORDER ~85, PLACEHOLDER ~13, over ~161 files. Prefer these over the literal.
// Note the shorthand forms render identically and are easy to miss when
// migrating: `#333` (55 uses) is BODY_TEXT and `#ddd` (8) is DIVIDER.
export const BODY_TEXT = '#333333';
export const BORDER = '#E3E3E3';
export const DIVIDER = '#DDDDDD';
export const PLACEHOLDER = '#D9D9D9';
export const WIDGET_SHADOW = '#305A6F14';
export const LEGACY_WIDGET_BACKGROUND = '#EAEEF0';
// Sidebar expand/collapse toggle, carried over from the original sidebar.
export const NAVBAR_TOGGLE = '#D6DEE2';
export const NAVBAR_TOGGLE_HOVER = '#C4D0D6';

// Values from the designer-approved Jobs, Approvals and System Fields pages
// (.agents/rules/page-patterns.md) that had no token.
export const INACTIVE_GREY = '#CCCCCC'; // Inactive or draft state label, hidden column, unpinned pin
export const MUTED_RED = '#D6827D'; // Withdrawn or rejected state label
export const ALERT_RED = '#E37D7A'; // Filter count badge, past expiry date
export const LIGHT_GREY = '#F2F2F2'; // Selected table row, Create pill label
export const SELECTION_BAR = '#F7FCFC'; // Bulk selection bar
export const SUBTLE_BORDER = '#EEEEEE'; // Page tabs border, table scroll arrows
export const CHECKBOX_TEAL = '#15C7C0'; // Checked table checkbox
export const HEADING_GREY = '#727272'; // Wizard step heading, future step number
export const LABEL_GREY = '#838383'; // Review labels, radio labels
export const SCOUT_BLUE_HOVER = '#0C74A4'; // Sortable table header hover

export const OPAQUE_GREEN = '#EFFDF3';
export const OPAQUE_BLUE = 'rgba(109, 190, 191, 0.12)';
export const OPAQUE_PINK = 'rgba(247, 161, 255, 0.12)';
export const OPAQUE_RED = 'rgba(252, 239, 239, 1)';
export const OPAQUE_DARK_BLUE = 'rgba(252, 239, 239, 1)';
export const OPAQUE_PURPLE = '#F2EDFE';
export const OPAQUE_YELLOW = '#FCF4EA';
